module.exports = __webpack_public_path__ + "img/am_logo.996e8976.png";